
module.exports = function () {
    $(window).on('load', function() {
        $(".ratings").show();
        $(".reviews").show();
    });
}